module.exports = __webpack_public_path__ + "static/media/arrow-down-purple.e41d0d57.svg";